import React from 'react';
import { Field } from 'formik';
import { Fields, Columns, Checkbox } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS } from '../Form/Form.types';
import { Props } from './RelatedToEmployedGrossSalary.types';

const RelatedToEmployedGrossSalary: React.FC<Props> = ({ prefix }) => {
  const getName = (field: FIELDS): string => {
    return `${prefix}.${FIELDS.RELATED_TO_EMPLOYED_GROSS_SALARY}.${field}`;
  };

  return (
    <>
      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.BONUS_INCOME}
          name={getName(FIELDS.BONUS_INCOME)}
          variant={VARIANTS_TYPES.CURRENCY}
          extraContent={[
            {
              position: 'bottom',
              variant: 'component',
              content: (
                <Field component={Checkbox} title={'Guaranteed'} name={getName(FIELDS.IS_GUARANTEED_BONUS_INCOME)} />
              ),
            },
          ]}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.COMMISSION_INCOME}
          name={getName(FIELDS.COMMISSION_INCOME)}
          variant={VARIANTS_TYPES.CURRENCY}
          extraContent={[
            {
              position: 'bottom',
              variant: 'component',
              content: (
                <Field
                  component={Checkbox}
                  title={'Guaranteed'}
                  name={getName(FIELDS.IS_GUARANTEED_COMMISSION_INCOME)}
                />
              ),
            },
          ]}
        />
      </Columns>

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.OVERTIME_INCOME}
          name={getName(FIELDS.OVERTIME_INCOME)}
          variant={VARIANTS_TYPES.CURRENCY}
          extraContent={[
            {
              position: 'bottom',
              variant: 'component',
              content: (
                <Field component={Checkbox} title={'Guaranteed'} name={getName(FIELDS.IS_GUARANTEED_OVERTIME_INCOME)} />
              ),
            },
          ]}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.SHIFT_ALLOWANCE_INCOME}
          name={getName(FIELDS.SHIFT_ALLOWANCE_INCOME)}
          variant={VARIANTS_TYPES.CURRENCY}
          extraContent={[
            {
              position: 'bottom',
              variant: 'component',
              content: (
                <Field
                  component={Checkbox}
                  title={'Guaranteed'}
                  name={getName(FIELDS.IS_GUARANTEED_SHIFT_ALLOWANCE_INCOME)}
                />
              ),
            },
          ]}
        />
      </Columns>
    </>
  );
};

export default RelatedToEmployedGrossSalary;
